import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '@components/components.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';

const sharedModules = [
  CommonModule,
  RouterModule,
  DirectivesModule,
  FormsModule,
  PipesModule,
  ReactiveFormsModule,
  ComponentsModule,
];

@NgModule({
  imports: sharedModules,
  exports: [sharedModules],
})
export class SharedModule {}
